module.exports = __webpack_public_path__ + "static/media/Eric_L.ae873a58.jpg";